import { Loader } from '@googlemaps/js-api-loader'

const API_KEY = 'AIzaSyAlDrciAoup0vODRe_A0zhKDyiEmEr-nwI'

const options = {
  apiKey: API_KEY,
  version: 'weekly',
  libraries: ['geometry', 'places']
}

class GoogleMapsService {
  constructor() {
    this.google = null
  }

  async init() {
    if (this.google) {
      return this.google
    }

    const loader = new Loader(options)
    this.google = await loader.load()

    return this.google
  }
}

export default new GoogleMapsService()
